import { Flex as AntFlex } from "antd";

const Flex = AntFlex;

export default Flex;
